import script from "./sms-texts-configuration-templates.vue?vue&type=script&setup=true&lang=ts"
export * from "./sms-texts-configuration-templates.vue?vue&type=script&setup=true&lang=ts"

import "./sms-texts-configuration-templates.vue?vue&type=style&index=0&id=1c04840c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c04840c"]])

export default __exports__